import { Box, Divider, Typography } from "@mui/material";

import { useBszPlannerContext } from "../../context/bszPlannerContext";
import BszSectionCard from "../../../1_BSZFinderApp/components/sectionCards/BszSectionCard";
import { useTheme } from "@mui/material/styles";
import { getSubjectLabel } from "../../../1_BSZFinderApp/components/sectionCards/werHilftSection/config/subjectConfig";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

export default function PlannerDeadlinesSection() {
  const theme = useTheme();
  const { currentUser } = useAppContext();
  const { projects = [], selectedClass = null } = useBszPlannerContext();
  const visibleProjects = selectedClass
    ? projects.filter((project) =>
        (project.classes || []).some((cls) => cls.id === selectedClass.id),
      )
    : projects.filter((project) => project.teacherId === currentUser.id);
  const upcomingDeadlines = [...visibleProjects]
    .filter((project) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const due = new Date(project.dueDate);
      due.setHours(0, 0, 0, 0);

      return due >= today;
    })
    .sort(
      (a, b) => new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime(),
    )
    .slice(0, 5);

  const getDaysRemaining = (dueDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const due = new Date(dueDate);
    due.setHours(0, 0, 0, 0);

    return Math.ceil((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  };

  return (
    <BszSectionCard
      title={
        selectedClass
          ? `Kommende Deadlines ${selectedClass.name}`
          : "Deine Deadlines"
      }
      defaultExpanded={false}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography variant="body2" color={theme.palette.text.secondary}>
          Die nächsten 5:
        </Typography>

        <Box
          sx={{
            maxHeight: 250,
            overflowY: "auto",
            pr: 1,
          }}
        >
          {upcomingDeadlines.map((project) => {
            const daysRemaining = getDaysRemaining(project.dueDate);
            return (
              <Box key={project.id}>
                <Typography fontWeight={600}>
                  {getSubjectLabel(project.subjectName)}
                  {" · "}
                  {project.title}
                </Typography>

                <Typography
                  variant="body2"
                  color={
                    daysRemaining <= 7
                      ? theme.palette.text.lightPurple
                      : theme.palette.text.secondary
                  }
                >
                  {new Date(project.dueDate).toLocaleDateString("de-CH")}
                  {" · "}
                  {daysRemaining < 0
                    ? `${Math.abs(daysRemaining)} Tage überfällig`
                    : daysRemaining === 0
                      ? "Heute fällig"
                      : `${daysRemaining} Tage verbleibend`}
                </Typography>

                <Divider sx={{ mt: 1 }} />
              </Box>
            );
          })}
        </Box>
      </Box>
    </BszSectionCard>
  );
}
